// src/components/Hero.js
import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowDown } from "lucide-react";

export default function Hero({ imageData, heroIndex, isFullscreen }) {
    if (isFullscreen) return null;
    const fontFlag = imageData.hero.light?.[heroIndex];
    console.log("Current image:", imageData.hero.light[heroIndex]);
    // Pick text color based on "light"/"dark" category
    const isLightFont = fontFlag === "light";

    const textColor = isLightFont ? "text-white" : "text-black";
    const subTextColor = isLightFont ? "text-white/70" : "text-black/70";
    const arrowColor = isLightFont ? "text-white/70" : "text-black/70";

    return (
        <div className="relative h-full w-full overflow-hidden">
            {/* Background Image */}
            <AnimatePresence mode="wait">
                <motion.div
                    key={imageData.hero.images[heroIndex]}
                    initial={{ opacity: 0, scale: 1.05 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 1.2, ease: "easeInOut" }}
                    className="absolute inset-0 bg-cover bg-center"
                    style={{
                        backgroundImage: `url(${imageData.hero.images[heroIndex]})`,
                    }}
                />
            </AnimatePresence>

            {/* Softer Gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-black/10 to-transparent" />

            {/* Text overlay */}
            <div className="relative z-10 h-full flex flex-col items-center justify-end text-center px-6 pb-24">
                <motion.h1
                    className={`text-4xl sm:text-5xl md:text-6xl font-semibold tracking-tight drop-shadow-md ${textColor}`}
                    initial={{ y: 20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                >
                    ZeusYohaan
                </motion.h1>

                <motion.p
                    className={`mt-4 text-lg sm:text-xl md:text-2xl max-w-xl ${subTextColor}`}
                    initial={{ y: 20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.8, delay: 0.35 }}
                >
                    Through My Lens Across Cultures — Sri Lanka, Turkey, Egypt, Jordan, India
                </motion.p>

                <motion.div
                    className={`absolute bottom-10 inset-x-0 flex justify-center ${arrowColor}`}
                    initial={{ y: 0 }}
                    animate={{ y: [0, -8, 0] }}
                    transition={{ repeat: Infinity, duration: 1.8 }}
                >
                    <ArrowDown className="w-7 h-7" />
                </motion.div>
            </div>
        </div>
    );
}
